import { BillingAccount } from "../../types";
import { Typography } from "../atoms/Typography";
import {
  DataTable,
  DataListSimpleHeader,
  DataListBody,
  DataListRow,
  DataListBodyItem,
} from "../atoms/Table";

/**
 * BillingAccountList Component
 */
type BillingAccountListProps = {
  billingAccounts: BillingAccount[];
};

const flexRatio = [2, 2, 1, 1, 1];

const headerTitles = [
  "名前",
  "メールアドレス",
  "部署",
  "請求書の郵送",
  "請求書のメール送信",
];

export function BillingAccountList({
  billingAccounts,
}: BillingAccountListProps) {
  const items = billingAccounts.map((billingAccount: BillingAccount) => {
    return (
      <DataListRow flexRatio={flexRatio} key={billingAccount.id}>
        <DataListBodyItem>
          <Typography size={2} withEllipsis={true}>
            {billingAccount?.contactName}
          </Typography>
        </DataListBodyItem>
        <DataListBodyItem>
          <Typography size={2} withEllipsis={true}>
            {billingAccount?.contactEmailAddress}
          </Typography>
        </DataListBodyItem>
        <DataListBodyItem>
          <Typography size={2} withEllipsis={true}>
            {billingAccount?.department || "-"}
          </Typography>
        </DataListBodyItem>
        <DataListBodyItem>
          <Typography size={2}>
            {billingAccount?.sendMail ? "する" : "しない"}
          </Typography>
        </DataListBodyItem>
        <DataListBodyItem>
          <Typography size={2}>
            {billingAccount?.sendEmail ? "する" : "しない"}
          </Typography>
        </DataListBodyItem>
      </DataListRow>
    );
  });

  return (
    <DataTable>
      <DataListSimpleHeader titles={headerTitles} flexRatio={flexRatio} />
      <DataListBody rows={items} />
    </DataTable>
  );
}
